import React, { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import api, { apiErrorMessage } from "@/lib/api";

export default function AdminFranchisesMetrics() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/admin/franchises/metrics"); setRows(data); }
      catch (e) { setErr(apiErrorMessage(e)); }
    })();
  }, []);

  if (err) return <div className="text-rose-300">{err}</div>;

  return (
    <div data-testid="admin-franchises-metrics" className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow flex items-center gap-2"><BarChart3 className="h-3 w-3" /> Franchise metrics</div>
        <h1 className="headline-xl">Rollup</h1>
      </header>
      <section className="glass-panel overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[0.7rem] tracking-[0.22em] uppercase text-lifted-mute font-bebas border-b border-white/5">
              <th className="px-4 py-3">Franchise</th><th>Compliance</th><th>Partners</th><th>Completed</th><th>Cancelled</th><th>Revenue</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.franchise_id} data-testid={`admin-franchise-metric-${r.franchise_id}`} className="border-b border-white/5">
                <td className="px-4 py-3 text-lifted-text">{r.territory_name}</td>
                <td>{{
                  pending: <span className="chip">Pending</span>,
                  approved: <span className="chip chip--green">Approved</span>,
                  suspended: <span className="chip">Suspended</span>,
                  rejected: <span className="chip">Rejected</span>,
                }[r.compliance_status]}</td>
                <td className="font-anton text-lifted-green">{r.partners_count}</td>
                <td className="font-anton text-lifted-green">{r.orders_completed}</td>
                <td className="text-lifted-text">{r.orders_cancelled}</td>
                <td className="text-lifted-text">${((r.total_revenue_cents || 0) / 100).toFixed(2)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-lifted-mute">No franchises yet.</td></tr>}
          </tbody>
        </table>
      </section>
    </div>
  );
}
